export default __webpack_public_path__ + "static/media/sk.6096aeda.svg";